import EventBus from './event-bus';
import PlayerStateRepository, { PlayerState } from './player-state';
import IdleTracker from 'idle-tracker';
import { HlsConfig } from 'hls.js';

export default class BaseCoreController {

    private idleTracker: IdleTracker | void = undefined;

    protected wasInitialized = false;

    constructor(
        protected eventBus: EventBus,
        protected playerStateRepository: PlayerStateRepository,
        private alwaysCollapseControlBarOnIdle: boolean
    ) {
        this.setupIdleTracker();
    }

    public revealControlBar(): void {
        this.updateState({ isControlBarVisible: true });
    }

    public hideControlBar(): void {
        const skipWhileNotPlaying = !this.playerStateRepository.state.isPlaying && !this.alwaysCollapseControlBarOnIdle;

        if (skipWhileNotPlaying || this.playerStateRepository.state.alwaysShowControlBar) {
            return;
        }

        this.updateState({ isControlBarVisible: false });
    }

    private setupIdleTracker() {
        this.idleTracker = new IdleTracker({
            timeout: 3000,
            onIdleCallback: this.trackIdle.bind(this),
        });

        this.idleTracker.start();
    }

    private trackIdle({ idle }: { idle: boolean }) {
        const wasIdle = this.playerStateRepository.state.isIdle;

        // edge detection
        if (idle === wasIdle) {
            return;
        }

        this.updateState({
            isIdle: idle
        });

        if (idle) {
            this.hideControlBar();
        } else {
            this.revealControlBar();
        }
    }

    public dispose(): void {
        this.idleTracker && this.idleTracker.end();
    }

    protected updateState(partialState: Partial<PlayerState>, context?: string): void {
        this.playerStateRepository
            .setState(partialState, context);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public updateOverrides(hlsConfigOverrides: Partial<HlsConfig>): void {
        // to be implemented by child classes
    }
}
